"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const inertia_react_1 = require("@inertiajs/inertia-react");
const classnames_1 = __importDefault(require("classnames"));
const IconSuccess = () => (react_1.default.createElement("svg", { className: "ml-4 mr-2 flex-shrink-0 w-4 h-4 text-white fill-current", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" },
    react_1.default.createElement("polygon", { points: "0 11 2 9 7 14 18 3 20 5 7 18" })));
const IconDanger = () => (react_1.default.createElement("svg", { className: "ml-4 mr-2 flex-shrink-0 w-4 h-4 text-white fill-current", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" },
    react_1.default.createElement("path", { d: "M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm1.41-1.41A8 8 0 1 0 15.66 4.34 8 8 0 0 0 4.34 15.66zm9.9-8.49L11.41 10l2.83 2.83-1.41 1.41L10 11.41l-2.83 2.83-1.41-1.41L8.59 10 5.76 7.17l1.41-1.41L10 8.59l2.83-2.83 1.41 1.41z" })));
const ButtonClose = ({ color, onClick }) => {
    const className = (0, classnames_1.default)("block  w-2 h-2 fill-current", {
        "text-red-700 group-hover:text-red-800": color === "red",
        "text-green-700 group-hover:text-green-800": color === "green",
    });
    return (react_1.default.createElement("button", { onClick: onClick, type: "button", className: "focus:outline-none group mr-2 p-2" },
        react_1.default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "235.908", height: "235.908", viewBox: "278.046 126.846 235.908 235.908" },
            react_1.default.createElement("path", { d: "M506.784 134.017c-9.56-9.56-25.06-9.56-34.62 0L396 210.18l-76.164-76.164c-9.56-9.56-25.06-9.56-34.62 0-9.56 9.56-9.56 25.06 0 34.62L361.38 244.8l-76.164 76.165c-9.56 9.56-9.56 25.06 0 34.62 9.56 9.56 25.06 9.56 34.62 0L396 279.42l76.164 76.165c9.56 9.56 25.06 9.56 34.62 0 9.56-9.56 9.56-25.06 0-34.62L430.62 244.8l76.164-76.163c9.56-9.56 9.56-25.06 0-34.62z" }))));
};
exports.default = () => {
    const [visible, setVisible] = (0, react_1.useState)(true);
    const { flash, errors } = (0, inertia_react_1.usePage)().props;
    const numOfErrors = Object.keys(errors).length;
    (0, react_1.useEffect)(() => {
        setVisible(true);
    }, [flash, errors]);
    return (react_1.default.createElement("div", null,
        flash.success && visible && (react_1.default.createElement("div", { className: "mb-8 flex items-center justify-between bg-green-500 rounded max-w-3xl" },
            react_1.default.createElement("div", { className: "flex items-center" },
                react_1.default.createElement(IconSuccess, null),
                react_1.default.createElement("div", { className: "py-4 text-white text-sm font-medium" }, flash.success)),
            react_1.default.createElement(ButtonClose, { onClick: () => setVisible(false), color: "green" }))),
        (flash.error || numOfErrors > 0) && visible && (react_1.default.createElement("div", { className: "mb-8 flex items-center justify-between bg-red-500 rounded max-w-3xl" },
            react_1.default.createElement("div", { className: "flex items-center" },
                react_1.default.createElement(IconDanger, null),
                react_1.default.createElement("div", { className: "py-4 text-white text-sm font-medium" },
                    flash.error && flash.error,
                    numOfErrors === 1 && "There is one form error",
                    numOfErrors > 1 && `There are ${numOfErrors} form errors.`)),
            react_1.default.createElement(ButtonClose, { onClick: () => setVisible(false), color: "red" })))));
};
